async function fetchSession () {
  return new Promise((resolve, reject) => {
    const timeoutLength = 10000 // 1 second
    const timeoutId = setTimeout(() => {
      reject(new Error('Session fetch timed out'))
    }, timeoutLength)

    const checkForDataLayerExistence = () => {
      if (window.dataLayer && window.dataLayer.length > 2) {
        const sessionEntry = window.dataLayer.find(entry => entry.hasOwnProperty('session'))
        if (sessionEntry && sessionEntry.session) {
          clearTimeout(timeoutId)
          clearInterval(intervalId)
          resolve(sessionEntry.session)
        }
      }
    }
    const intervalId = setInterval(() => {
      checkForDataLayerExistence()
    }, 500)

    checkForDataLayerExistence()
  })
}

export default fetchSession
